module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/karol-gulatowski-6c67da009439796d22ed322f0cfddde3.png";